import getConfig from 'next/config';
import SecondaryMenu from '../components/SecondaryMenu';
import DontWaitBannerSection from 'components/composed/sections/DontWaitBannerSection';
import { NextSeo } from 'next-seo';
import * as React from 'react';

const { publicRuntimeConfig } = getConfig();

function About() {
  return (
    <div className="about">
      <NextSeo title="About Us" />
      <div className="top-banner">
        <div className="copy">
          <h1>About Us</h1>
        </div>
      </div>

      <SecondaryMenu />

      <div className="main-copy">
        <div className="text">
          <h2>About Trademark Genius</h2>
          <h3>
            Trademark Genius is dedicated to providing top notch service and
            support to small businesses and entrepreneurs looking to protect
            their business and brand worldwide.
          </h3>

          <img
            className="mobile"
            src={`${publicRuntimeConfig.basePath}/about-tg.png`}
            alt=""
            layout="fill"
          />

          <div className="left-s">
            <h4>Our Mission</h4>
            <p>
              Trademark Genius's mission is to provide small business owners
              with proven, simplified, efficient and competitively affordable
              solutions to protecting their brands and businesses.
            </p>
            <p>
              Our #1 goal is to provide a "One Stop Shop" for business and brand
              protection in one place, all being easily accessible from the
              comfort of your own home. Our top priority and value that
              consistently shows in our services is placing business owners
              first, ensuring they are informed each step of the way and on the
              fastest track to meeting their goals. We strive to aid owners who
              cannot afford a full-service property attorney to avoid missing
              any critical steps associated in Trademark ownership.
            </p>
            <p>
              We are known for providing the highest level of support through
              each of our services, including; Trademark Registration, Trademark
              Searches, Trademark Monthly Monitoring, Office Action Responses,
              Statement of Use Filing & many more.
            </p>
            <p>
              We do not operate as a law firm. No information on our website is
              to be used as legal advice. Each situation is handled specific to
              the owner's needs, meaning all outcomes are variable.
            </p>
          </div>
          <div className="divider desktop"></div>
          <div className="right-s">
            <h4>Our Processing</h4>
            <p>
              Trademark Genius is made up of a team of highly trained
              specialists armed with detailed critical industry knowledge that
              is continually expanding. We are a top providing and trusted
              source for our customers, always valuing confidentiality and
              ensuring information is secured.
            </p>
            <p>
              We take pride in our efficient design, processing structure and
              strong focus on next level customer service along the entirety of
              the way. Our services are known for being seamless, user-friendly
              and above all transparent. The quality and close attention to
              detail of our services cannot be matched, as we are constantly
              improving and staying ahead of industry standards.
            </p>
            <p>
              Trademark Genius thanks you for visiting and using our services.
              We look forward to aiding you in every step of the journey towards
              protecting your business and brand.
            </p>
          </div>
        </div>
        <img
          className="desktop"
          src={`${publicRuntimeConfig.basePath}/about-tg.png`}
          alt=""
          layout="fill"
        />
      </div>

      <DontWaitBannerSection link="/registration-trademark" />
    </div>
  );
}

export default About;
